export const getNameInitials = (name: string, limit = 2): string => {
    const names = name.trim().split(' ');
    if (names.length === 1 && names[0]) {
        return names[0].substring(0, limit).toUpperCase();
    }
    const initials = names.map((n) => n[0]);
    return initials
        .join('')
        .replace(/\s/g, '')
        .substring(0, limit)
        .toUpperCase();
};
